import { Injectable } from '@angular/core';
import { ApiServiceService } from '../common/api-service.service';
import { SubscriptionService } from '../subscription/subscription.service';
import { Observable, tap } from 'rxjs';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  public checkAuth: BehaviorSubject<string> = new BehaviorSubject<string>(
    localStorage.getItem('authenticated') || "false"
  );
  private loggedIn = false;

  constructor(
    private apiService: ApiServiceService,
    private router: Router,
    private subscriptionService: SubscriptionService
  ) {}

  login(email: string, password: string): Observable<any> {
    return this.apiService.login(email, password).pipe(
      tap(response => {
        if (response.status === 'success') {
          this.loggedIn = true;
          const { profileId, sessionToken } = response.data;
          this.storeSessionData(profileId, sessionToken);
          this.subscriptionService.fetchCurrentSubscription(profileId).subscribe();
        }
      })
    );
  }

  logout(): void {
    this.loggedIn = false;
    this.clearSessionData();
  }

  isLoggedIn(): boolean {
    return !!localStorage.getItem('sessionToken') && !!localStorage.getItem('profileId');
  }

  private storeSessionData(profileId: string, sessionToken: string): void {
    localStorage.setItem('profileId', profileId);
    localStorage.setItem('sessionToken', sessionToken);
  }

  private clearSessionData(): void {
    localStorage.removeItem('profileId');
    localStorage.removeItem('sessionToken');
    localStorage.removeItem('current_subscription');
    localStorage.removeItem('user_current_plan');
  }
}
